import React from 'react'

import { DisplayResultProps } from './excel-drop-area.types'

const DisplayResult = (props: DisplayResultProps) => {
  return (
    props.result && (
      <div className={props.result.isError ? 'excelErrorTable' : 'excelMessageArea'} id='header'>
        <p className='text-break'>{props.result.message}</p>
      </div>
    )
  )
}

export default DisplayResult
